// @flow
import axios from "axios";
import { throttleAdapterEnhancer } from "axios-extensions";

let apiUrl = "";
if (process.env && process.env.REACT_APP_API_URL) {
    apiUrl = process.env.REACT_APP_API_URL;
} else {
    throw new Error("API URL error");
}

let apiToken = "";
if (process.env && process.env.REACT_APP_TOKEN) {
    apiToken = process.env.REACT_APP_TOKEN;
} else {
    throw new Error("API Token error");
}

export const API_URL = apiUrl;

export const API_TOKEN = apiToken;

export const api = axios.create({
    baseURL: API_URL,
    timeout: 120000,
    adapter: throttleAdapterEnhancer(axios.defaults.adapter, {
        threshold: 2 * 1000,
    }),
    headers: {
        Authorization: `bearer ${API_TOKEN}`,
    },
});
